<template>
  <v-autocomplete 
    :filled="!outlined"
    :outlined="outlined"
    :label="label"
    :value="value"
    :disabled="disabled"
    :clearable="clearable"
    :hide-no-data="hideNoData"
    :hide-selected="hideSelected"
    :hide-search="hideSearch"
    :hide-details="hideDetails"
    :hint="hint"
    :rules="rules"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :return-object="returnObject"
    :error="error"
    :error-messages="errorMessages"
    :loading="loading"
    color="primary"
    class="rounded-lg app-autocomplete-no-border"
    @input="e => $emit('input', e)"
    @click:clear="e => $emit('click:clear', e)"
    @change="e => $emit('change', e)"
  />
</template>

<script>
export default {
  name: 'AppAutocomplete',

  props: {
    label: {
        type: String,
        required: true
    },
    value: {
        type: [String, Number, Object],
        default: undefined,
    },
    disabled: {
        type: Boolean,
        default: false
    },
    clearable: {
        type: Boolean,
        default: false
    },
    hideNoData: {
      type: Boolean,
      default: false
    },
    hideSelected: {
      type: Boolean,
      default: false
    },
    hideSearch: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    hint: {
        type: String,
        default: ''
    },
    rules: {
        type: Array,
        default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: [String, Array, Function],
      default: 'text'
    },
    itemValue: {
      type: [String, Array, Function],
      default: 'value'
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: [String, Array],
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style>
.app-autocomplete-no-border.v-text-field--outlined fieldset {
  border: none !important;
} 

.app-autocomplete-no-border > .v-input__control > .v-input__slot   {
  -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
}

.app-autocomplete-no-border  > div > .v-input__slot  {
  border: solid 1px var(--v-primary-base) !important;
  color: transparent !important; 
  height: 60px !important;
}

.app-autocomplete-no-border .v-text-field__slot,
.app-autocomplete-no-border .v-input__prepend-inner,
.app-autocomplete-no-border .v-input__slot {
  background-color: #FFFFFF !important;
}

.app-autocomplete-no-border  > div.v-input__control > .v-input__slot  {
    border: solid 1px var(--v-primary-base) !important;
    color: transparent !important; 
    height: 60px !important;
}

.app-autocomplete-no-border.v-select--is-multi  > div.v-input__control > .v-input__slot  {
    height: auto !important;
    min-height: 60px;
}

.app-autocomplete-no-border  > .v-input__control > .v-input__slot::before {
    border: none !important;
}

.app-autocomplete-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > label,
.app-autocomplete-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > label {
    color:  var(--v-primary-base);
    font-weight: 600;
}

.app-autocomplete-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > input,
.app-autocomplete-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > input,
.app-autocomplete-no-border > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections {
    color:  #56565B !important;
}

.app-autocomplete-no-border > .v-input__control > .v-input__slot {
  -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
}

.app-autocomplete-no-border.v-input--is-disabled  > .v-input__control > .v-input__slot {
  border-color: #c2c2c2 !important;
}

.app-autocomplete-no-border.v-input--is-disabled  > .v-input__control > .v-input__slot > .v-select__slot > label {
  color: #c2c2c2 !important;
}

.app-autocomplete-no-border.v-select--is-multi > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections > span {
   padding-top: 5px !important;
   padding-left:5px !important;
}

.app-autocomplete-no-border.v-select--is-multi > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections > span:not(:last-child)::after {
  content: "\002C";
}

.app-autocomplete-no-border.v-input--is-dirty > .v-input__control > .v-input__slot,
.app-autocomplete-no-border > .v-input__control > .v-input__slot {
  padding-left: 10px !important;
}

.app-autocomplete-no-border.v-input--is-dirty > .v-input__control > .v-input__slot,
.app-autocomplete-no-border.v-input--is-focused  > .v-input__control > .v-input__slot {
  padding-top: 16px !important;
}

.app-autocomplete-no-border  > .v-input__control > .v-input__slot::before {
    border: none !important;
}

.app-autocomplete-no-border.error--text  > div > .v-input__slot  {
  border-color: var(--v-error-base) !important;
}

.app-autocomplete-no-border.v-input--is-disabled  > .v-input__control > .v-input__slot {
  border-color: #c2c2c2 !important;
}

.app-autocomplete-no-border.v-input--is-disabled  > .v-input__control > .v-input__slot > .v-select__slot > label {
  color: #c2c2c2 !important;
}
</style>